import React from 'react'
import AsignatedResponsable from '../../containers/asignatedResponsable'

const GestionCasesPage = () => {
  return <AsignatedResponsable />
}

export default GestionCasesPage
